import config from 'config';
import format from 'date-fns/format';

export default function(dateString, fmt) {
    var dateFormatWithoutTimezone = dateString.slice(0, -6);
    var dateFormat = fmt || config.dateTimeFormat || 'MMMM D, YYYY h:mma';

    return format(
        dateFormatWithoutTimezone,
        dateFormat
    );
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/common/formattedDate.js